import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Circle, Sparkles } from "lucide-react";

export default function AchievementTimeline({ timeline }) {
  return (
    <div className="relative pl-6" data-testid="portfolio-achievement-timeline">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10" />
      <div className="space-y-5">
        {(timeline || []).map((m, i) => (
          <motion.div
            key={m.day} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: i * 0.06 }}
            className="relative" data-testid={`timeline-milestone-day-${m.day}`}
          >
            <div className={`absolute -left-6 top-0.5 w-3.5 h-3.5 rounded-full flex items-center justify-center ${m.earned ? "bg-emerald-400" : m.is_next ? "bg-indigo-400" : "bg-white/10"}`}>
              {m.earned ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-950" /> : m.is_next ? <Sparkles className="w-2.5 h-2.5 text-indigo-950" /> : <Circle className="w-2 h-2 text-slate-400" />}
            </div>
            <p className={`text-sm font-semibold ${m.earned ? "text-white" : m.is_next ? "text-indigo-300" : "text-slate-400"}`}>Day {m.day} · {m.label}</p>
            {m.earned && m.earned_at && <p className="text-[11px] text-slate-400 mt-0.5">Earned {new Date(m.earned_at).toLocaleDateString()}</p>}
            {m.is_next && <p className="text-[11px] text-indigo-400/70 mt-0.5">Next milestone</p>}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
